import { apiCrm } from '../../../../http';

class PriceCatalogService {
  constructor() {
    this.BASE_URL = '/price-catalogs';
  }

  getPriceCatalogs(queryParams) {
    return apiCrm.get(`${this.BASE_URL}/`, {
      params: queryParams
    });
  }

  getPriceCatalogById(id) {
    return apiCrm.get(`${this.BASE_URL}/${id}`);
  }

  createPriceCatalog(data) {
    return apiCrm.post(`${this.BASE_URL}/`, data);
  }

  enableDisablePriceCatalog(id, data) {
    return apiCrm.patch(`${this.BASE_URL}/status/${id}`, data);
  }

  getProductsByPriceCatalogId(id) {
    return apiCrm.get(`${this.BASE_URL}/${id}/products`);
  }

  enableDisableProductInPriceCatalog(catalogId, productId, data) {
    return apiCrm.patch(
      `${this.BASE_URL}/${catalogId}/products/${productId}/status`,
      data
    );
  }

  getDiscountMatrixByCatalogId(id) {
    return apiCrm.get(`${this.BASE_URL}/${id}/discounts`);
  }

  updatePriceCatalog(catalogId, data) {
    return apiCrm.patch(`${this.BASE_URL}/${catalogId}`, data);
  }

  updateProductPriceInCatalog(catalogId, productId, data) {
    return apiCrm.patch(
      `${this.BASE_URL}/${catalogId}/products/${productId}`,
      data
    );
  }

  updatePriceCatalogDiscountMatrix(catalogId, data) {
    return apiCrm.put(`${this.BASE_URL}/${catalogId}/discounts`, {
      discountMatrix: data
    });
  }
}

export default new PriceCatalogService();
